import './App.css';
import { AuthProvider } from './auth/AuthProvider';
import Home from './components/Home/Home';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

function App() {
  return (
    // 2. Wrap your app with QueryClientProvider
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Home />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
